export default {
  body: {
    overflow: 'hidden',
    flex: '1',
  },
  fileName: {
    fontSize: 14,
    fontWeight: 500,
    color: '#344054',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
  },
  fileSize: {
    fontSize: 14,
    fontWeight: 300,
    color: '#475467',
  },
  remove: {
    fontSize: 14,
    fontWeight: 500,
    color: '#475467',
    cursor: 'pointer',
    '&:hover': {
      color: '#D92D20',
    },
  },
  deleteIcon: {
    cursor: 'pointer',
  },
  percentage: {
    fontSize: 14,
    fontWeight: 500,
    color: '#344054',
    mt: 'auto',
    lineHeight: '1',
  },
  error: {
    wrapper: {
      mt: '2px',
    },
    msgPrimary: {
      fontSize: 14,
      fontWeight: 400,
      color: '#D92D20',
    },
    msgSecondary: {
      fontSize: 14,
      fontWeight: 600,
      color: '#B42318',
    },
  },
};
